import { createApp } from 'vue'
import Card from '../vue/Card.vue'

if (document.getElementById('cardVue')) {
    createApp({})
        .component('Card', Card)
        .mount('#cardVue')
}